import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Message from "../../../controls/Message";
import api from "../../../../api";
import { sleep } from "../../../../utils";
import AutoSuggestWithApiDatasource from "../../../controls/autoSuggest/AutoSuggestWithApiDatasource";
import { addItemToCart, updateCartItem } from "../../../../actions/cart";

class SearchBox extends Component {
  state = {
    showMessage: false,
    searchText: "",
    products: [],
    loading: false
  };

  onChange = async e => {
    const searchText = e.target.value;

    this.setState({
      searchText
    });

    if (!searchText || searchText.length < 2) {
      this.setState({
        products: [],
        loading: false
      });
      return;
    }

    this.setState({
      loading: true
    });

    try {
      const response = await api.product.fetchPage(
        1,
        20,
        null,
        searchText
      );

      const data = response.data || {};

      const products = Array.isArray(data.products)
        ? data.products
        : Array.isArray(data.value)
          ? data.value
          : Array.isArray(data)
            ? data
            : [];

      this.setState({
        products,
        loading: false
      });

      if (products.length === 1 && this.isExactMatch(searchText, products[0])) {
        await sleep(200);
        this.onSelected(products[0]);
      }
    } catch (error) {
      console.error("Product search failed:", error);

      this.setState({
        products: [],
        loading: false,
        showMessage: true
      });
    }
  };

  isExactMatch = (searchText, product) => {
    if (!product) {
      return false;
    }

    const search = String(searchText || "")
      .trim()
      .toLowerCase();

    const id = String(product.id || "").toLowerCase();
    const sku = String(product.sku || "").trim().toLowerCase();
    const upc = String(product.upc || "").trim().toLowerCase();
    const gtin = String(product.gtin || "").trim().toLowerCase();
    const ean = String(product.ean || "").trim().toLowerCase();
    const isbn = String(product.isbn || "").trim().toLowerCase();
    const name = String(product.name || "").trim().toLowerCase();

    return (
      id === search ||
      sku === search ||
      upc === search ||
      gtin === search ||
      ean === search ||
      isbn === search ||
      name === search
    );
  };

  onSelected = selectedItem => {
    if (!selectedItem) {
      return;
    }

    this.setState({
      searchText: "",
      products: [],
      loading: false
    });

    this.updateCart(selectedItem);
  };

  updateCart = item => {
    const { cart } = this.props;
    const existingItem = cart[item.id];

    if (existingItem) {
      const obj = this.constructCartObjForUpdate(existingItem);
      this.props.updateCartItem(obj);
    } else {
      const obj = this.constructCartObjForAddNew(item);
      this.props.addItemToCart(obj);
    }
  };

  constructCartObjForUpdate = obj => {
    const clone = {};
    Object.assign(clone, obj);

    clone.qty += 1;

    return clone;
  };

  constructCartObjForAddNew = obj => {
    const clone = {};
    Object.assign(clone, obj);

    clone.qty = 1;
    clone.price = Number(clone.price || 0);
    clone.discount = 0;
    clone.sellingPrice = clone.price;
    clone.totalPrice = clone.price;

    return clone;
  };

  onMessageCloseClick = () => {
    this.setState({
      showMessage: false
    });
  };

  handleKeyDown = event => {
    if (event.key === "F11") {
      console.log(event.key);
    }
  };

  render() {
    const {
      products,
      searchText,
      showMessage
    } = this.state;

    return (
      <Fragment>
        <Message
          style={{ width: 430 }}
          title="Message"
          message="Something went wrong. Please try again later"
          show={showMessage}
          isError={true}
          onCloseClick={this.onMessageCloseClick}
        />

        <AutoSuggestWithApiDatasource
          searchText={searchText}
          width="450px"
          onKeyDown={this.handleKeyDown}
          onLeave={this.onLeave}
          onChange={this.onChange}
          onSelected={this.onSelected}
          datasource={products}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = ({ cart }) => ({
  cart: cart.items
});

export default connect(
  mapStateToProps,
  {
    updateCartItem,
    addItemToCart
  }
)(SearchBox);



